/** * 数组方法 * @author tan 2022/2/23*/

/**
 * 提取数组对象
 * @param {*} n
 * @param {*} offset
 */
 function limitBy(n, offset) {
  offset = offset ? parseInt(offset, 10) : 0
  n = parseInt(n)
  return typeof n === 'number' ? this.slice(offset, offset + n) : this
}

/**
 * 跳过数组N个，取之后所有
 * @param {*} n
 */
function skipBy(n) {
  n = parseInt(n)
  return typeof n === 'number' ? this.slice(n) : this
}
/**
 * 根据元素值移除数组中的一个元素
 * @param array 数组
 * @param prod 属性名
 * @param value 属性值
 * @returns {string}
 */
function removeArrayElement(array, prod, value) {
  let index = -1
  for (let i = 0; i < array.length; i++) {
    if (array[i][prod] === value) {
      index = i
      break
    }
  }
  if (index >= 0) {
    array.splice(index, 1)
  }
}
// eslint-disable-next-line no-extend-native
Array.prototype.skip = skipBy
// eslint-disable-next-line no-extend-native
Array.prototype.limit = limitBy
// eslint-disable-next-line no-extend-native
Array.prototype.removeArrayElement = removeArrayElement
// eslint-disable-next-line no-extend-native
Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] === val) return i
  }
  return -1
}
// eslint-disable-next-line no-extend-native
Array.prototype.remove = function(val) {
  var index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}

// eslint-disable-next-line no-extend-native
Function.prototype.stopShake = function(num) {
  var time
  var $this = this
  var lazyTime = num || 1500
  return () => {
    if (time && time + lazyTime >= Date.now()) {
      return
    }

    time = Date.now()

    return $this.call()
  }
}

//  数组去空
// eslint-disable-next-line no-extend-native
Array.prototype.removeEmpty = function() {
  for (var i = 0; i < this.length; i++) {
    // eslint-disable-next-line valid-typeof
    if (this[i] === '' || typeof this[i] === 'undefined' || this[i] === undefined || this[i] === null) {
      this.splice(i, 1)
      i--
    }
  }
  return this
}
